function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export const WideArrowDownward = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0001 16.0001C11.7664 16.0005 11.54 15.9191 11.3601 15.7701L5.36005 10.7701H5.36005C4.9348 10.4166 4.87659 9.78531 5.23005 9.36005C5.58352 8.9348 6.2148 8.87659 6.64005 9.23005V9.23005L12.0001 13.7101L17.3601 9.39005V9.39005C17.7888 9.0419 18.4186 9.10721 18.7667 9.53593C18.7678 9.5373 18.7689 9.53868 18.7701 9.54005C19.1374 9.95247 19.1008 10.5846 18.6884 10.9519C18.6696 10.9687 18.6501 10.9847 18.6301 11L12.6301 15.83C12.445 15.9556 12.2232 16.0154 12.0001 16L12.0001 16.0001Z"
}));